var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIconInverted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7755 8.23276C13.6333 8.08368 13.441 8 13.2405 8C13.04 8 12.8477 8.08368 12.7055 8.23276L9.98103 11.0663L7.29453 8.23276C7.15234 8.08368 6.95999 8 6.7595 8C6.55901 8 6.36667 8.08368 6.22448 8.23276C6.15335 8.30717 6.09689 8.3957 6.05836 8.49324C6.01984 8.59078 6 8.6954 6 8.80107C6 8.90674 6.01984 9.01136 6.05836 9.1089C6.09689 9.20644 6.15335 9.29497 6.22448 9.36938L9.44221 12.7632C9.51276 12.8383 9.59669 12.8978 9.68917 12.9384C9.78165 12.9791 9.88084 13 9.98103 13C10.0812 13 10.1804 12.9791 10.2729 12.9384C10.3654 12.8978 10.4493 12.8383 10.5198 12.7632L13.7755 9.36938C13.8466 9.29497 13.9031 9.20644 13.9416 9.1089C13.9802 9.01136 14 8.90674 14 8.80107C14 8.6954 13.9802 8.59078 13.9416 8.49324C13.9031 8.3957 13.8466 8.30717 13.7755 8.23276Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconInverted);
export default __webpack_public_path__ + "static/media/check-icon-inverted.a3984ffc7f0c4978ef1ea33faa1eb93a.svg";
export { ForwardRef as ReactComponent };